import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormField from './ReduxFormsField';
import cloneDeep from 'lodash/cloneDeep';

const validate = values => {
  let errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = ['Name is required'];
  } else if (values.name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  return errors;
};

class AddForm extends Component {
  static propTypes = {
    ...formPropTypes,
    entityType: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    action: PropTypes.string,
  };

  static defaultProps = {
    action: 'Add',
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);

    submitValues.name = submitValues.name.trim();

    return this.props.onSubmit(values);
  };

  render() {
    const { entityType, handleSubmit, onCancel, submitting, action } = this.props;

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div className="modal__content">
          <h3>{`${action} ${entityType}`}</h3>
          <Field name="name" component={ReduxFormField} label={`${entityType} Name`} required={true}>
            <input type="text" />
          </Field>
        </div>
        <div className="modal__actions">
          <div className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'addForm',
  validate,
})(AddForm);



// WEBPACK FOOTER //
// ./src/common/forms/AddForm.js